import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { MLPredict, MLPredictFeedstockSchedule } from '../interfaces/predictModalLoad';
import { SitesShortForm } from '../interfaces/regions';

@Injectable({
  providedIn: 'root'
})
export class PredictService {

  baseUrl = environment.baseUrl;
 
  constructor(private http: HttpClient) {}
    
  getMLLoadModelRegionSites(marketId: number, sType: number): Observable<SitesShortForm[]>{
    var url = `${this.baseUrl}masters/GetMLLoadModelRegionSites?regionId=${marketId}&type=${sType}`;
    return this.http.get<SitesShortForm[]>(url);
  }

  getMLPredictFeedstockSchedule(): Observable<MLPredictFeedstockSchedule[]> {
    var url = `${this.baseUrl}plantperformanceoverridedata/getMLPredictFeedstockSchedule`;
    
    return this.http.get<MLPredictFeedstockSchedule[]>(url);
  }

  getMLPredictSchedule(siteId: number, fDate: string, tDate: string): Observable<MLPredict[][]> {
    var url = `${this.baseUrl}plantperformanceoverridedata/getMLPredictSchedule?SiteId=${siteId}&FromDate=${fDate}&ToDate=${tDate}`;
   
    return this.http.get<MLPredict[][]>(url);
  }

  saveMLPredictFeedstockSchedule(siteId: number, pDate: string, streamIds: string, mcf: number): Observable<any> {
    var url = `${this.baseUrl}plantperformanceoverridedata/saveMLPredictFeedstockSchedule` +
    `?SiteId=${siteId}` +
    `&ScheduleDate=${encodeURIComponent(pDate)}` +
    `&StreamIds=${encodeURIComponent(streamIds)}` +
    `&MCF_Predict=${mcf}`;
    return this.http.post<any>(url, {});
  }
}
